import { createContext } from 'react';
import type { ApprovalEntity } from 'ui-product-approvals-common';

export const ApprovalContext = createContext<ApprovalEntity | undefined>(
  undefined
);
